import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { DataResponse, Deck, DeckChanges, UpdateDeckRequest } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { styleDeckElementBackground, styleDeckElementBackgroundSmall } from "@ponder-features/user/decks/deck-utils";
import { DeckBaseComponent } from "@ponder-features/user/decks/deck/deck-base.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { Subscription, take } from "rxjs";

@Component({
    selector: "magic-deck-banner",
    imports: [],
    templateUrl: "./magic-deck-banner.component.html"
})
export class MagicDeckBannerComponent implements AfterViewInit {
    @Input({ required: true }) deck!: Deck;
    @Input({ required: true }) deckComponent!: DeckBaseComponent;

    @ViewChild("deckBannerOuter") containerOuterRef!: ElementRef<HTMLElement>;
    @ViewChild("deckBannerInner") containerInnerRef!: ElementRef<HTMLElement>;

    private onBannerUpdatedSub!: Subscription;
    private onWindowResizeSub!: Subscription;

    public constructor(
        private ponderDataClient: PonderDataClient, 
        private events: EventBroker) {
            this.onBannerUpdatedSub = this.events.deck.deckBackgroundUpdatedEvent.subscribe({
                next: (deck: Deck) => {
                    if (deck.id === this.deck.id) {
                        this.updateBannerBackground();
                    }
                }
            });

            this.onWindowResizeSub = this.events.ui.windowResizeEvent.subscribe({
                next: () => {
                    this.updateBannerBackground();
                }
            });
    }

    public ngOnDestroy(): void {
        this.onBannerUpdatedSub?.unsubscribe();
        this.onWindowResizeSub?.unsubscribe();
    }
    
    public ngAfterViewInit(): void {
        this.updateBannerBackground();
    }

    private updateBannerBackground(): void {
        if (isMobileScreen()) {
            styleDeckElementBackgroundSmall(
                this.containerOuterRef.nativeElement, 
                this.containerInnerRef.nativeElement, 
                this.deck.color!, 
                this.deck.backgroundCardId);
        } else {
            styleDeckElementBackground(
                this.containerOuterRef.nativeElement, 
                this.containerInnerRef.nativeElement, 
                this.deck.color!, 
                this.deck.backgroundCardId);
        }
    }

    public onTitleLoseFocus(event: Event): void {
        var target = (event.target as HTMLInputElement);
        var value = target.value;
        
        if (value === this.deck.name) {
            // No change.
            return;
        }

        var request = new UpdateDeckRequest({
            deckId: this.deck.id,
            deckChanges: new DeckChanges({
                name: value
            })
        });

        this.ponderDataClient
            .deckUpdate(request)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response.success) {
                        this.deck.name = value;
                    } else {
                        target.value = this.deck.name!;
                    }
                },
                error: (_: any) => {
                    // Revert the input value to the original name on error.
                    target.value = this.deck.name!;
                }
            });
    }
}